module.exports = __webpack_public_path__ + "img/image_album_set_your_senses.43b05510.jpg";